import { IClickEventData } from 'types/analytics';

export const TEXT_KEYS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'invitee-page__title',
    STATUS: 'invitee-page__status',
    DESCRIPTION: 'invitee-page__description',
    REWARD_DESCRIPTION: 'invitee-page__reward-description',
    BUTTON_BUY: 'invitee-page__button-text',
    NOTE: 'invitee-page__message'
};

export const DEFAULT_STAT_VALUE = '0';

export const BUTTON_BUY_ANALYTICS_ACTION = 'buy the game';

export const INVITEE_ANALYTICS = (actionName: string): IClickEventData => ({
    location: 'page',
    category: 'action',
    action: `${actionName}`
});
